export default __webpack_public_path__ + "static/media/trr-drink-coffee-latte.aa738a29.png";